module.exports = __webpack_public_path__ + "assets/7373b8edfb3d6e22769f2eac487315c6.mp3";